module.exports = __webpack_public_path__ + "assets/img/Chama-Landing-Page-+-Website-w960.3d497c57.jpg";